import { DropDownList } from "@progress/kendo-react-dropdowns";
import { InputField } from "../../components/form/input.field.component";
import { API_END_POINT } from "../../constants";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import StateModel from "../../models/masters/state-model";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { useGetStates } from "../../apiclient/master/useGetStateApi";

interface StateEditProps {
    data: StateModel;
    isViewMode?: boolean;
    onClose?: (status: SubmitStatus, data: any) => any;
}

const StateEntry: React.FC<StateEditProps> = ({ ...props }) => {
    let { data, onClose,isViewMode } = props;
    const title = data?.stateId > 0 ? "Edit State" : "Add State";
  
    let initialValue: StateModel = {
        stateId: data?.stateId ? data.stateId : 0,
        code: data?.code,
        name: data?.name,
    };

    const validationSchema = Yup.object().shape({
        name: Yup.string()
        .required("Required")
        .test("check-duplicate-name", "State name already exists", (value) => {
          // Ensure the value is compared in a case-insensitive manner
          return (
            value &&
            !existingName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
            (data?.name && value === data.name) // Allow current name during update
          );
        }), 
        code: Yup.string()
      .required("Required   ")
      .test("check-duplicate-code", "Code already exists", (value) => {
        return (
          value &&
          !existingCode.includes(value) ||
          (data?.code && value === data.code) // Allow current code during update
        );
      }),
    });

    const [existingCode, setExistingCode] = useState<string[]>([]);
    const [existingName, setExistingName] = useState<string[]>([]);

    const { data: fetchedState } = useGetStates();
  
    useEffect(() => {
        if (fetchedState) {
            setExistingCode(fetchedState.map((cat: any) => cat.code));
            setExistingName(fetchedState.map((cat: any) => cat.name));
        }
    }, [fetchedState]);

    return (
        <>
            <FormikModelDialog
                width="50%"
                title={title}
                initialData={initialValue}
                validationSchema={validationSchema}
                show={!!data}
                onClose={onClose}
                endpoint={API_END_POINT.MASTER}
                showAddAnother={true}
                postRoute="State/SaveState"
                isViewOnly ={isViewMode}
                isUpDateEntityDetails={data?.stateId > 0 ? true : false}
            >
                <div>
                    <div className="row">
                        <div className="col-3">
                            <InputField maxLength={100} label="Code *" name="code" />
                        </div>
                        <div className="col-6">
                            <InputField maxLength={100} label="State *" name="name" />
                        </div>       
                    </div>
                </div>
            </FormikModelDialog>
        </>
    );
};

export default StateEntry;
